const defaultGetFormDataOptions = {
    inputSelector: "input, textarea, select",
    skipEmpty: false
};

/**
 * @param form
 * @param {object} [options]
 * @param {string} [options.inputSelector] XPath/CSS selector for input elements inside form to be handled
 * @param {boolean} [options.skipEmpty] Skip inputs with empty values
 * @return {object}
 */
export function getFormData(form, options = {}) {
    options = {
        ...defaultGetFormDataOptions,
        ...options
    };

    let inputs = form.querySelectorAll(options.inputSelector);

    var data = {};

    for (let input of inputs) {
        if (input.type === "checkbox") {
            if (input.checked) data[input.name] = input.value;
            continue;
        }

        if (options.skipEmpty && input.value === "" || input.value === undefined) continue;

        data[input.name] = input.value;
    }

    return data;
}


// WEBPACK FOOTER //
// ./src/utils/forms.js